// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice.js';
import cartReducer from './cartSlice.js';
import stickerCartReducer from './stickerCartSlice.js';
import favoritesReducer from './favoritesSlice.js';
import uiReducer from './uiSlice.js';
import themeReducer from './themeSlice.js';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    stickerCart: stickerCartReducer,
    favorites: favoritesReducer,
    ui: uiReducer,
    theme: themeReducer,
  },
});

export default store;